/**
 * Play Icon Component
 *
 * Play icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/play-icon
 */
import { createIconNode } from '../create-icon';
const PLAY_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [{ d: 'M2.73779 2.97595C2.73779 1.81286 4.0201 1.10575 5.00342 1.72693L12.9565 6.75134C13.8739 7.33088 13.8739 8.66887 12.9565 9.24841L5.00342 14.2728C4.02023 14.8939 2.73813 14.1876 2.73779 13.0248V2.97595Z', stroke: 'currentColor', strokeWidth: '0.996364px' }],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [{ d: 'M6.5 6.82202C6.5 5.63839 7.80708 4.92093 8.80566 5.5564L16.9424 10.7341C17.8686 11.3236 17.8686 12.6759 16.9424 13.2654L8.80566 18.4441C7.80711 19.0795 6.50009 18.362 6.5 17.1785V6.82202Z', stroke: 'currentColor' }],
    },
});
export function PlayIcon(props) {
    return createIconNode(PLAY_ICON, props);
}
//# sourceMappingURL=play.js.map